import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {LoanService} from '../../shared-component/service/loan/loan.service';

@Component({
    selector: 'app-sent-link',
    templateUrl: './sent-link.component.html',
    styleUrls: ['./sent-link.component.css']
})
export class SentLinkComponent implements OnInit {

    public loanId: number;
    public loanDetail: any = {};
       
    constructor(
        public router: Router,
        public activeRoute: ActivatedRoute,
        public loanService: LoanService,
        private modalService: NgbModal
    ) {
    }

    ngOnInit() {
        this.activeRoute.data.subscribe((res: any) => {
            if (res.loanDetail && Object.keys(res.loanDetail).length) {
                this.loanId = res.loanDetail.id;
                this.loanDetail = res.loanDetail;
            }
        });
    }

    sendBtlyToCustomer() {
        this.loanService.sendBitly(this.loanId).subscribe((res: any) => {
            this.router.navigateByUrl(`/loanApplication/newLoanProcess/${this.loanId}/sentLink`);
        });
    }

    openIncomeDocumentUploadPopup(content) {
        this.modalService.open(content, { backdrop: 'static', centered: true });
    }
}
